
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API_URL,
  fetchOptions: {
    mode: 'cors'
  }
});

// Auth link to add JWT token to requests when available
const authLink = setContext((_, { headers }) => {
  // Get the JWT token from localStorage if it exists
  const userData = localStorage.getItem('user');
  let token = null;

  if (userData) {
    try {
      const user = JSON.parse(userData);
      token = user.user?.jwt;
    } catch (e) {
      console.error('Error parsing user data from localStorage', e);
    }
  }

  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token || '',
    }
  };
});

export const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});
